import moment from "moment";

import { ratingsActions as A } from "./reducer";
import DashboardApi from "../../api/DashboardApi";
//import { _setTickets } from "../tickets/actions";
import { timers } from "../../config";
import Axios from 'axios';
import _ from 'lodash';


// timer to handle time between executing search after user stops typing
let userInpTimerId = null;


//[SEARCH RATINGS] 
export const getRatings = (options = { resetPage: false }) => async (dispatch, getState) => {
    dispatch(_loadingSearch(true));
    if(options.resetPage) {
      dispatch(_setPage(1));
      
    }
    const searchStore = getState().ratings;
    const searchOptions = searchStore.searchOptions;
    const paginationOptions = searchStore.paginationOptions;
    const { date, variable } = searchOptions;
    //[TESTING] - ya7ya el habd :D
    const dateFrom = date.from;
    const dateTo = date.to;
    const dateQuery = {
        from: dateFrom,
        to: dateTo
    }
    const SearchOptions = { dateQuery, variable }
    //const sameEndDate = moment(date.to).isSame(moment(), 'day');
    console.log('[SEARCHBAR] -  search options', SearchOptions);

    try {
      const result = await DashboardApi.searchRatings(SearchOptions, paginationOptions);
      if (result.success) {
        //should return array of formated tickets, each is an object with its trip and rating data
        const formatedTickets = unwindRating(result.data.v3_tickets);
 
        // set rating tickets
        dispatch(
        _RatingTckets({
            ratingTickets: formatedTickets,
            total_pages: result.data.total_pages
          })
        );
      } else {
        console.error("[SEARCH RATINGS] Error: ", result);
        dispatch(_loadingSearch(false));
      }
  
      dispatch(_loadingSearch(false));
    } catch (error) {
      if (Axios.isCancel(error)) {
        console.info('[SEARCH_RATINGS]: Previous request was cancelled!');
      } else {
        console.error(error);
        dispatch(_loadingSearch(false));
      }
    }
};

export const setPerPage = (per_page) => dispatch => {
    dispatch(_setPerPage(per_page));
    dispatch(getRatings({resetPage: true}));
}  

export const setPage = (page) => dispatch => {
    dispatch(_setPage(page));
    dispatch(getRatings());
}

export const setVariable = (variable) => dispatch => {
  clearTimeout(userInpTimerId);
  dispatch(_setVariable(variable));
  userInpTimerId = setTimeout(() => {
    dispatch(getRatings({resetPage: true}));
  }, timers.inputTrigger);
};

export const setDate = ({ from, to, range }) => (dispatch, getState) => {
    from = moment(from).startOf('day').format();
    to = moment(to).endOf('day').format();
    dispatch(_setDate({ from, to, range }));
  
    // trigger search and get stats
    dispatch(getRatings({resetPage: true}));
}

export const setDateRange = (range) => dispatch => {
    let from, to = null;
    switch (range) {
      case "today":
        from = moment().startOf('day').format();
        to = moment().endOf('day').format();
        break;

      case "yesterday":
        from = moment().subtract(1, 'day').startOf('day').format();
        to = moment().subtract(1, 'day').endOf('day').format();
        break;
    
      case "last_7":
        from = moment().subtract(7, 'days').startOf('day').format();
        to = moment().subtract(1, 'days').endOf('day').format();
        break;
    
      case "last_30":
        from = moment().subtract(30, 'days').startOf('day').format();
        to = moment().subtract(1, 'days').endOf('day').format();
        break;
    
      case "this_month":
        from = moment().startOf('month').format();
        to = moment().endOf('day').format();
        break;
    
      case "last_30":
        from = moment().subtract(30, 'days').startOf('day').format();
        to = moment().endOf('day').format();
        break;
      
      case "last_month":
        from = moment().subtract(1, 'months').startOf('month').format();
        to = moment().subtract(1, 'months').endOf('month').format();
        break;

      case "last_2_months":
        from = moment().subtract(2, 'months').startOf('month').format();
        to = moment().subtract(1, 'months').endOf('month').format();
        break;

      case "last_3_months":
        from = moment().subtract(3, 'months').startOf('month').format();
        to = moment().subtract(1, 'months').endOf('month').format();
        break;

      default:
        from = moment().startOf('day').format();
        to = moment().endOf('day').format();
        break;
    }
  
    dispatch(setDate({from, to, range}));
}
/**
 * Formats tickets to array of objects, each contains trip with its rating data
 * @param {*} ratedTickets 
 * @returns {Array} finalRatings
 * @author Aya Solaiman
 */
function unwindRating(ratedTickets){
  console.log('teckits length:', ratedTickets.length);
  console.log('Raquest result - tickets:', ratedTickets);

  //if old tickets(rating:{isObject})
  let oldRatings = [];
  let newRatings = []; //if new ratings: [{},{}]
  let finalRatings = [];
  //separate old ratings & new ratings
  ratedTickets.forEach(element => {
    if(!Array.isArray(element.rating)){
      oldRatings.push(element);
      finalRatings.push(element);
    }
    if(Array.isArray(element.rating)){
      newRatings.push(element);
      let goingTrip, returnTrip;
      //let myGoTrip = [], myReTrip = [];
      element.rating.forEach( tripRate => {
        //console.log('Current Rating:', tripRate)
        //if rate1 -- trip1 || rate1 -- trip2
        if(Number(tripRate.trip_sub_Id) === element.myTrips[0].TripSubData_Id){
          //myGoTrip.push(element.myTrips[0]);
          //going trip data
          goingTrip = {
            ActionDate: element.ActionDate,
            CardID: element.CardID,
            CardStatusID: element.CardStatusID,
            UserEmail: element.UserEmail,
            UserName: element.UserName,
            email: element.email,
            myTrips: [element.myTrips[0]],
            name: element.name,
            phone: element.phone,
            rating: tripRate
          }
          //console.log('going trip:', goingTrip);
          finalRatings.push(goingTrip);
        }else{
          //myReTrip.push(element.myTrips[1]);
          //return trip data
          returnTrip = {
            ActionDate: element.ActionDate,
            CardID: element.CardID,
            CardStatusID: element.CardStatusID,
            UserEmail: element.UserEmail,
            UserName: element.UserName,
            email: element.email,
            myTrips: [element.myTrips[1]],
            name: element.name,
            phone: element.phone,
            rating: tripRate
          }
          //console.log('return trip:', returnTrip);
          finalRatings.push(returnTrip);
        }
        
      })

    }
  });
  console.log('Old Ratings', oldRatings.length, '\n', oldRatings);
  console.log('New Ratings', newRatings.length, '\n', newRatings);
  console.log('Final Ratings:', finalRatings.length, '\n', finalRatings);
  return finalRatings;
}

/** Dispatchers */
function _loadingSearch(status) {
    return {
      type: A.loading_search,
      data: status
    };
}

function _RatingTckets({ratingTickets, total_pages}){

    const data = {
        ratingTickets,
        total_pages
    };

    return {
        type: A.set_rating_tickets,
        data
    }
}
  
function _setDate({ from, to, range }) {
    return {
      type: A.set_date,
      data: {
        from, to, range
      }
    };
}
    
function _setVariable(variable) {
    return {
      type: A.set_variable,
      data: variable
    };
}
  
function _setPerPage(per_page) {
    return {
      type: A.set_per_page,
      data: per_page
    };
}
  
function _setPage(page) {
    return {
      type: A.set_page,
      data: page
    };
 }
  